import React from 'react';
import { Box, List, ListItem, Typography } from "@mui/material";
import ImgUpload from "../../../components/imgUpload";
import { useStylesCreation } from "./style";
import { useApolloClient } from "@apollo/client";
import { ASSEST_MASTER_TABLE } from "../../../graphql/queries";
import { BackdropContext } from "../../../contexts";
import { assestType } from '../../../utils/common'


export const Assests = (props) => {
      const client = useApolloClient();
      const classes = useStylesCreation()
      const backdrop = React.useContext(BackdropContext);
      const [uuid, setUUID] = React.useState(1);
      const [list, setList] = React.useState([])
      const [indexs, setIndexs] = React.useState(0);

      const handleList = (val, index) => {
            setIndexs(index)
      };
      const getAssests = () => {
            backdrop.setBackDrop({
                  ...backdrop,
                  open: true,
                  message: "Loading",
            });
            client.query({
                  query: ASSEST_MASTER_TABLE(),
                  fetchPolicy: 'network-only',
            }).then((res) => {
                  setList(res?.data?.assets_master)
                  backdrop.setBackDrop({
                        ...backdrop,
                        open: false,
                        message: "",
                  });

            }).catch((err) => { console.log(err) })
      }
      React.useEffect(() => {
            getAssests()
            // eslint-disable-next-line
      }, [])

      return (
            <>
                  <Box className={classes.imagebox3}>
                        <List style={{ display: 'flex', marginBottom: '14px', marginLeft: "12px" }} className={classes.list}>
                              {
                                    list?.filter(x => x?.id !== assestType?.Thumbnails)?.map((x, index) => {
                                          return (
                                                <ListItem className={index === indexs ? classes.listText : classes.list}
                                                      onClick={() => handleList(x?.id, index)}
                                                >
                                                      <Typography className={classes.tabname}>{x?.type}</Typography>
                                                </ListItem>
                                          )

                                    })
                              }
                        </List>
                  </Box>
                  <br />
                  <Box className={classes.imagebox1}>


                        {
                              list?.filter(x => x?.id !== assestType?.Thumbnails)?.map((x, index) => {
                                    return (
                                          <>
                                                {
                                                      indexs === index &&
                                                      <ImgUpload
                                                            accept={x?.accept}
                                                            setUUID={setUUID ?? null}
                                                            uuid={uuid ?? null}
                                                            updateImageURL={props?.setImages}
                                                            handleFile={props?.handleAssetFile}
                                                            selectedImageURL={props?.images ?? []}
                                                            id={x?.order}
                                                            companyID={props?.companyId ?? ""}
                                                            link
                                                      />
                                                }

                                          </>
                                    )
                              })
                        }

                  </Box>
            </>

      )
}